<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        filled
        label="Company name"
        v-model="internalData.companyName"
        :rules="[rules.required]"
      ></v-text-field>
      <v-text-field
        filled
        label="Address line 1"
        v-model="internalData.address.line1"
      ></v-text-field>
      <v-text-field
        filled
        label="Address line 2"
        v-model="internalData.address.line2"
      ></v-text-field>
      <v-text-field
        filled
        label="Town / City"
        v-model="internalData.address.town"
      ></v-text-field>
      <v-text-field
        filled
        label="Postcode"
        v-model="internalData.address.postcode"
      ></v-text-field>
      <v-text-field
        filled
        label="Phone number"
        v-model="internalData.phoneNumber"
        hint="E.g. +44 1234 123456"
        :rules="[rules.phoneNumber]"
      ></v-text-field>
      <v-text-field
        filled
        label="Email address"
        v-model="internalData.email"
        :rules="[rules.email]"
        hint="example@example.com"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { textFieldRules } from '@/common'

export default {
  name: 'ContractorDetailsForm',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      internalData: { address: {}, ...this.data },
      rules: textFieldRules,
    }
  },
  watch: {
    internalData: {
      handler(newValue) {
        this.$emit('update:data', newValue)
      },
      deep: true,
    },
  },
}
</script>